import type { FC } from 'react';

import { Box, ListItemButton, ListItemText, Radio } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

export const SortingOptionsListMobileFragment = graphql(/* GraphQL */ `
  fragment SortingOptionsListMobileFragment on SearchProductResult {
    availableSortingOrders {
      key
      displayName
    }
  }
`);

export type SortingOptionsListMobileProps = {
  maskedData: FragmentType<typeof SortingOptionsListMobileFragment>;
  /** Callback fired when a user selects a sorting key */
  onChange?: (sortingKey: string) => void;
  /** Key of the currently selected sorting option */
  selectedSortingKey: string;
};

/**
 * Dialog to select filter values for a specific filter
 * */
export const SortingOptionsListMobile: FC<SortingOptionsListMobileProps> = ({
  maskedData,
  onChange,
  selectedSortingKey,
}) => {
  const { availableSortingOrders } = getFragmentData(SortingOptionsListMobileFragment, maskedData);

  return (
    <Box overflow="auto">
      {availableSortingOrders.map(({ key, displayName }) => {
        const labelId = `sorting-option-${key}`;
        const isActive = key === selectedSortingKey;

        return (
          <ListItemButton key={key} onClick={() => onChange?.(key)} disableRipple>
            <Radio
              edge="start"
              checked={isActive}
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-labelledby': labelId }}
              sx={{ marginRight: 0 }}
            />
            <ListItemText
              id={labelId}
              primary={displayName}
              primaryTypographyProps={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            />
          </ListItemButton>
        );
      })}
    </Box>
  );
};
